var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDetailsBattryCharg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_484_4642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3435 6.75H3.87673C2.69354 6.75 1.73438 7.70909 1.73438 8.89219V15.1078C1.73438 16.2909 2.69354 17.25 3.87673 17.25H18.3435C19.5267 17.25 20.4858 16.2909 20.4858 15.1078V8.89219C20.4858 7.70909 19.5267 6.75 18.3435 6.75Z",
    stroke: "#9C4900",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7344 10.25V13.7497",
    stroke: "#9C4900",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.776 13.0026H9.10938L11.4427 8.33594V11.0026H13.1094L10.776 15.6693V13.0026Z",
    fill: "#9C4900"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_484_4642"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.0019,
    height: 24,
    fill: "white",
    transform: "translate(0.28125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailsBattryCharg);
export default __webpack_public_path__ + "static/media/Details_battry_charg.48e99236626e5ff3a81a329cf06930fa.svg";
export { ForwardRef as ReactComponent };